import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/dcm-2020/dcm-2020.github.io/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>Agenda: January 8, 12am - 5am UTC, 2021</h2>
    <table>
  <thead>
      <tr>
        <th colSpan="2" rowSpan="1"><p>Time</p></th>
        <th colSpan="1" rowSpan="1"><p>Type</p></th>
        <th colSpan="10" rowSpan="1"><p>Title</p></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colSpan="2" rowSpan="1"><p>12.00-12.30am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Keynote</p></td>
        <td colSpan="10" rowSpan="1">
        <p>Dr. Fei Wang, Associate Professor at Weill Cornell Medicine, Cornell University, USA.</p>
        <cite>Rethinking of Deep Learning in Analyzing Electronic Health Records.</cite>
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="1"><p>12.30-12.50am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Paper</p></td>
        <td colSpan="10" rowSpan="1">
        <p>Nicholas Soures, David Chambers, Zachariah Carmichael, Anurag Daram, Kal Clark, Pankil Shah, Dimpy Shah, Lloyd Potter, Dhireesha Kudithipudi.</p>
        <cite>SIRNET: Understanding Social Distancing Measures with Hybrid Neural Network Model for COVID-19 Infectious Spread.</cite>
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="1"><p>12.50-1.10am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Paper</p></td>
        <td colSpan="10" rowSpan="1">
        <p>Chenhao Lin , Jiongli Zhu , Chao Shen, Pengwei Hu, Qian Wang.</p>
        <cite>ELLG: Explainable Lesion Learning and Generation for Diabetic Retinopathy Detection.</cite>
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="1"><p>1.10-1.30am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Paper</p></td>
        <td colSpan="10" rowSpan="1">
        <p>Tengteng Zhang, Yiqin Yu, Zefang Tang, Xiang Zhang, Shaochun Li.</p>
        <cite>Unlocking the Power of Deep PICO Extraction: Step-wise Medical NER Identification.</cite>
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="1"><p>1.30-1.50am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Break</p></td>
        <td colSpan="10" rowSpan="1"><p></p></td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="1"><p>1.50-2.20am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Keynote</p></td>
        <td colSpan="10" rowSpan="1">
        <p>Dr. Shigeo Yamaguchi, Assistant Professor at School of Medicine, Keio University, Japan.</p>
        <cite>Bioinformatics analysis application “Socrates” can get over discordance between clinical expert and bioinformatician.</cite>
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="1"><p>2.20-2.40am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Paper</p></td>
        <td colSpan="10" rowSpan="1"><p>Akira Koseki, Reitaro Tokumasu, Daijo Inaguma.</p>
        <cite>CVD prediction of CKD Patients using Window-based Laboratory Tests and Drug Usage Covariates.</cite>
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="1"><p>2.40-3.00am UTC</p></td>
        <td colSpan="1" rowSpan="1"><p>Paper</p></td>
        <td colSpan="10" rowSpan="1"><p>Xu Min, Yiqin Yu, Shiwan Zhao, Shaochun Li.</p>
        <cite>Medical Outcome Prediction by Adaptive Knowledge Distillation.</cite>
        </td>
      </tr>
  </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      